<template>
    <div>
        <div style="padding: 0 20px;  ">
            <!--    新增角色按钮-->
            <div class="top" style="justify-content: space-between;">
                <div>
                    
                    <el-input v-model="query.medicinalName"
                              size="small"
                              placeholder="药品名称/通用名"
                              suffix-icon="el-icon-search"
                              style="width: 260px;margin-left: 20px">
                    </el-input>
                                       
                    <el-select v-model="query.medicinalType" size="small" style="width: 160px;margin-left: 20px">
                        <el-option key="KE_LI" label="中药颗粒" value="KE_LI"></el-option>
                        <el-option key="YING_PIAN" label="中药饮片" value="YING_PIAN"></el-option>
                        <el-option key="GAO_FANG" label="中药膏方" value="GAO_FANG"></el-option>
                        <el-option key="WAN_JI" label="中药丸剂" value="WAN_JI"></el-option>
                        <el-option key="FU_LIAO" label="辅料" value="FU_LIAO"></el-option>
                    </el-select>
                    <el-button type="primary" @click="search" style="width: 96px">查询</el-button>
                   <el-button type="primary" @click="openAdd" style="width: 68px">新增</el-button>
 
                </div>
                <div style="display:flex">
                   <el-button size="small" style="width: 96px;float:right;margin-right:10px" @click="excelExport">下载模板</el-button>                   
                   <el-upload
                    style="display: inline-block; margin-left:10px;margin-right:10px;width:100px;float:right;" 
                    action=""
                    :multiple="false"
                    :limit=1                    
                    accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"
                    :show-file-list="false"
                    :drag="false"
                    :http-request="uploadFile"
                    ref="excel"
                    >
                    <el-button size="small" style="width: 96px;float:left">批量导入</el-button>
                    </el-upload>                
                    
                </div>
            </div>
            <!--    角色信息表格-->
            <div>
                <el-table :data="tableData" v-loading="loading">
                    <el-table-column label="药品剂型">
                        <template slot-scope="scope">
                            <span v-if="scope.row.productSubType === 'KE_LI'">颗粒</span>
                            <span v-else-if="scope.row.productSubType === 'YING_PIAN'">饮片</span>
                            <span v-else-if="scope.row.productSubType === 'GAO_FANG'">膏方</span>
                            <span v-else-if="scope.row.productSubType === 'WAN_JI'">丸剂</span>
                            <span v-else-if="scope.row.productSubType === 'FU_LIAO'">辅料</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="药品名称" prop="productName"></el-table-column>
                    
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <el-button type="text" @click="editMedicinal(scope.row)">编辑</el-button>                           
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="pagination">
                <el-pagination
                        background
                        layout="total, prev, pager, next"
                        :current-page="pageNum"
                        :page-size="pageSize"
                        :total="total"
                        @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>
        <el-dialog title="新增" :visible.sync="dialogAddVisible" width="740px" :close-on-click-modal="false">
           
            <el-form :model="medicinalAdd" label-width="100px" size="small" :rules="rule" ref="add" style="margin-top: 20px">
                <div class="dialog-set">
                    <el-form-item label="药品剂型:" prop="productSubType">             
                     
                       <el-radio-group v-model="medicinalAdd.productSubType">
                            <el-radio label="KE_LI">中药颗粒</el-radio>
                            <el-radio label="YING_PIAN">中药饮片</el-radio>
                            <el-radio label="GAO_FANG">中药膏方</el-radio>
                            <el-radio label="WAN_JI">中药丸剂</el-radio>
                            <el-radio label="FU_LIAO">辅料</el-radio>
                        </el-radio-group>
                   </el-form-item>
                </div>

                <div class="dialog-set">
                    <el-form-item label="药品名称:" prop="productName">
                        <el-input v-model="medicinalAdd.productName" style="width: 240px"></el-input>
                    </el-form-item>
                    <el-form-item label="超剂量:" prop="overdose">
                        <el-input v-model="medicinalAdd.overdose" style="width: 240px"></el-input>
                    </el-form-item>
                </div>
                 <div class="dialog-set">
                     <el-form-item label="拼音简码:" prop="productPrefix">
                        <el-input v-model="medicinalAdd.productPrefix" style="width: 240px"></el-input>
                    </el-form-item>
                     <el-form-item label="拼音全拼:" prop="productPinyin">
                        <el-input v-model="medicinalAdd.productPinyin" style="width: 240px"></el-input>
                    </el-form-item>
                </div>    
                <div class="dialog-set">
                  <el-form-item label="禁忌药材:" prop="tabooMedicinals">
                    <div class="tag-box" @click="openTabooMedicinalsSet">
                        <el-tag
                                size="small"
                                style="margin-right: 4px"
                                v-for="item in medicinalAdd.tabooMedicinals"
                                :key="item.productNo"
                                type="info"
                                effect="plain">
                            {{ item.productName }}
                        </el-tag>
                    </div>
                </el-form-item>           
                </div>
            </el-form>
            
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogAddVisible = false">取 消</el-button>
                <el-button type="primary" @click="confirmAdd">确 定</el-button>
            </span>
        </el-dialog>

        <el-dialog title="配置禁忌药材" :visible.sync="tabooMedicinalsVisible" width="700px" :close-on-click-modal="false">
            <div style="text-align: center">
                <el-transfer
                        v-if="items.length !== 0"
                        style="text-align: left; display: inline-block"
                        v-model="overTabooMedicinals"
                        :props="{
                            key: 'productNo',
                            label: 'productName',
                        }"
                        filterable
                        filter-placeholder="搜索药材名称"
                        :titles="['药材', '已配置禁忌药材']"
                        :format="{
                            noChecked: '${total}',
                            hasChecked: '${checked}/${total}'
                         }"
                        ref="addTabooMedicinals"
                        :data="items">
                    <span slot-scope="{ option }">{{ option.productName }}</span>
                </el-transfer>
            </div>
            <div slot="footer" class="dialog-footer charge">
                <el-button @click="tabooMedicinalsVisible = false" style="width: 76px">取消</el-button>
                <el-button type="primary" @click="saveTabooMedicinals" style="width: 76px">确定</el-button>
            </div>
        </el-dialog>

       
        <el-dialog title="编辑药材" :visible.sync="dialogEditVisible" width="740px" :close-on-click-modal="false">
            
            <el-form :model="medicinalEdit" label-width="100px" size="small" :rules="rule" ref="add" style="margin-top: 20px">
                 <div class="dialog-set">
                    <el-form-item label="药品剂型:" prop="productSubType" >             
                     
                       <el-radio-group v-model="medicinalEdit.productSubType">
                            <el-radio label="KE_LI" v-if="medicinalEdit.productSubType=='KE_LI'">中药颗粒</el-radio>
                            <el-radio label="YING_PIAN" v-if="medicinalEdit.productSubType=='YING_PIAN'">中药饮片</el-radio>
                            <el-radio label="GAO_FANG" v-if="medicinalEdit.productSubType=='GAO_FANG'">中药膏方</el-radio>
                            <el-radio label="WAN_JI" v-if="medicinalEdit.productSubType=='WAN_JI'">中药丸剂</el-radio>                            
                        </el-radio-group>
                   </el-form-item>
                </div>
                <div class="dialog-set">

                    <el-form-item label="药品名称:" prop="productName">
                        <el-input v-model="medicinalEdit.productName" :disabled="true" style="width: 240px"></el-input>
                    </el-form-item>
                    <el-form-item label="超剂量:" prop="overdose">
                        <el-input v-model="medicinalEdit.overdose" style="width: 240px"></el-input>
                    </el-form-item>
                </div>
                 <div class="dialog-set">

                     <el-form-item label="拼音简码:" prop="productPrefix">
                        <el-input v-model="medicinalEdit.productPrefix" style="width: 240px"></el-input>
                    </el-form-item>
                     <el-form-item label="拼音全拼:" prop="productPinyin">
                        <el-input v-model="medicinalEdit.productPinyin" style="width: 240px"></el-input>
                    </el-form-item>
                </div>
             
            </el-form>
           
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogEditVisible = false">取 消</el-button>
                <el-button type="primary" @click="confirmEdit">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script type="text/javascript">
    export default {
        
        data() {
            return {
                // token
                authorization:localStorage.getItem('authorization'),
                // 搜索数据
                query: {                    
                    medicinalType: 'KE_LI',                   
                },
               
                // 表格页
                pageNum: 1,
                pageSize: 10,
                total: 0,
                // loading
                loading: true,
                // 列表数据
                tableData: [],
                
                // 新增弹窗
                dialogAddVisible: false,
                // 表单验证
                rule:{
                    productName:[{required: true, message: '请输入药品名称', trigger: 'blur'}],                    
                                     
                },
                tabooMedicinalsVisible:false,
                overTabooMedicinals: [],
                items: [],
                medicinalAdd: {
                   
                    // 药品剂型 颗粒饮片1
                    productSubType:'',                   
                    // 药品名称1
                    productName: '',
                    // 超剂量
                    overdose: '',
                    // 药品简码1
                    productPrefix: '',
                    productPinyin: '',
                    tabooMedicinals:'',
                    
                },
               
                dialogEditVisible: false,
                medicinalEdit: {                    
                    productNo :'',
                  // 药品剂型 颗粒饮片1
                    productSubType:'',                   
                    // 药品名称1
                    productName: '',
                    // 超剂量
                    overdose: '',
                    // 药品简码1
                    productPrefix: '',
                    productPinyin: '',                   
                }

            }
        },

        methods: {
            search(){
                this.getData();
            },
            // 获取列表数据
            getData() {                               
                this.loading = true
                let params = {                    
                    medicinalType: this.query.medicinalType,
                    medicinalName: this.query.medicinalName,
                }
                
                this.axios.post('/api-b/10050/100084/' + this.pageNum + '/' + this.pageSize,params,{
                    headers:{
                        Authorization: this.authorization
                    }
                }).then(res => {
                    if (res.data.code === 10000) {
                        if (res.data.data.list.length !== 0) {
                            this.tableData = res.data.data.list
                            this.total = res.data.data.total                            
                        } else {
                            this.$message.info('暂无药材')
                            this.tableData = []
                            this.total = 0
                        }
                    } else {
                        this.$message.error(res.data.message)
                        this.tableData = []
                        this.total = 0
                    }
                    this.loading = false
                }).catch(error => {
                    this.tableData = []
                    this.total = 0
                    this.loading = false
                })
                
            },            
            // 换页
            handlePageChange(val) {
                this.pageNum = val
                this.getData()
            },
            // 打开新增
            openAdd() {
                this.dialogAddVisible = true
                this.$nextTick(() => {
                    this.$refs.add.resetFields()
                    this.medicinalAdd.productSubType = this.query.medicinalType
                })
            }, 
            openTabooMedicinalsSet() {
                let params = {
                    medicinalType: this.medicinalAdd.productSubType,                    
                }
                this.axios.post('/api-b/10050/100084/1/999',params,{
                    headers:{
                        Authorization: this.authorization
                    }
                }).then(res => {
                    if (res.data.code === 10000) {
                        if (res.data.data.list !== null) {
                            this.items = res.data.data.list
                            this.tabooMedicinalsVisible = true
                            this.medicinalAdd.tabooMedicinals =''
                        } else {
                            this.$message.info('暂无数据')
                            this.items = []
                            this.medicinalAdd.tabooMedicinals =''
                        }
                    } else {
                        this.$message.error(res.data.message)
                        this.items = []
                        this.medicinalAdd.tabooMedicinals =''
                    }
                })
            },        
            saveTabooMedicinals() {
                let tbooMedicinals = []
                for (let i=0; i<this.overTabooMedicinals.length; i++){
                    let tbooMedicine = this.items.find(item => {
                        return item.productNo === this.overTabooMedicinals[i]
                    })
                    tbooMedicinals.push(tbooMedicine)
                }
                this.medicinalAdd.tabooMedicinals = tbooMedicinals
                this.tabooMedicinalsVisible = false
            },  
            // 确认新增
            confirmAdd() {
                this.$refs.add.validate(valid => {
                    if (valid) {
                        let params = {}
                        
                        params = {                      
                            
                            productSubType:this.medicinalAdd.productSubType,                   
                            // 药品名称1
                            productName: this.medicinalAdd.productName,
                            // 超剂量
                            overdose: this.medicinalAdd.overdose,
                            // 药品简码1
                            productPrefix: this.medicinalAdd.productPrefix,
                            productPinyin: this.medicinalAdd.productPinyin,
                           
                        }
                           
                        this.axios.post('/api-b/10050/100085/',params,{
                            headers:{
                                Authorization: this.authorization
                            }
                        }).then(res => {
                            if (res.data.code === 10000) {
                                this.dialogAddVisible = false
                                this.$message.success(res.data.message)
                                this.getData()
                                this.$nextTick(() => {
                                    this.$refs.add.resetFields()
                                })
                            } else  {
                                this.$message.error(res.data.message)
                            }
                        })
                    }
                })
            },
            
            // 获取药材详情,打开编辑
            editMedicinal(data) {
                let params = new FormData()
                params.append('productNo',data.productNo)
                this.axios.post('/api-b/10050/100087/',params,{
                    headers:{
                        Authorization: this.authorization
                    }
                }).then(res => {
                    if (res.data.code === 10000) {
                        this.medicinalEdit = res.data.data                   
                        this.dialogEditVisible = true                        
                    } else {
                        this.$message.error(res.data.message)
                    }
                })              
            },
          
            // 确认编辑
            confirmEdit() {
                
                let params = {}
                        
                params = {
                    
                    productNo :this.medicinalEdit.productNo,
                   
                    productSubType:this.medicinalEdit.productSubType,                   
                    // 药品名称1
                    productName: this.medicinalEdit.productName,
                    // 超剂量
                    overdose: this.medicinalEdit.overdose,
                    // 药品简码1
                    productPrefix: this.medicinalEdit.productPrefix,
                    productPinyin: this.medicinalEdit.productPinyin,                    
                }
                this.axios.post('/api-b/10050/100086/',params,{
                    headers:{
                        Authorization: this.authorization
                    }
                }).then(res => {
                    if (res.data.code === 10000) {
                        this.$message.success(res.data.message)
                        this.dialogEditVisible = false
                        this.getData()
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },
            
            excelExport(){
               this.axios.get('/api-b/10050/100212',{
                    headers:{
                        Authorization: this.authorization
                    }, responseType: "blob"
                }).then(response => {                   
                        const BLOB = response.data;
                        const headers = response.headers
                        this.fileName = JSON.parse(JSON.stringify(headers));
                        let arr = this.fileName["content-type"].split(";");
                        this.fileName = arr[1];     
                        let ar = this.fileName.split("=");
                        this.fileName = ar[1];                   
                        // Blob 对象表示一个不可变、原始数据的类文件对象（File 接口都是基于Blob）
                        const fileReader = new FileReader(); // FileReader 对象允许Web应用程序异步读取存储在用户计算机上的文件的内容
                        fileReader.readAsDataURL(BLOB);
                        // 开始读取指定的Blob中的内容。一旦完成，result属性中将包含一个data: URL格式的Base64字符串以表示所读取文件的内容
                        fileReader.onload = (event) => {
                            // 处理load事件。该事件在读取操作完成时触发
                            // 新建个下载的a标签，完成后移除。
                            let a = document.createElement("a");
                            a.download = revertUTF8(this.fileName);
                            a.href = event.target.result;
                            document.body.appendChild(a);
                            a.click();
                            document.body.removeChild(a);
                        }
                    
                })
            },
            uploadFile(item){

                let params = new FormData()
                params.append('file',item.file)

                this.axios.post('/api-b/10050/100214',item.file,{
                        headers:{
                            Authorization: this.authorization,
                            'Content-Type':'multipart/form-data'
                        }
                }).then(res => {
                    if (res.data.code === 10000) {
                        this.$message.success(res.data.message)
                        this.getData()                        
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            }

        },
        watch: {
            query: {
                handler() {
                    this.pageNum = 1
                    clearTimeout(this.timeout);
                    this.timeout = setTimeout(() => {
                        this.getData();
                    }, 300);
                },
                deep:true
            },
            
        },
        created() {            
            this.getData()          
            
        }
    }
    function revertUTF8(szInput) {
    var x,wch,wch1,wch2,uch="",szRet="";
    for (x=0; x<szInput.length; x++) {
        if (szInput.charAt(x)=="%") {
            wch =parseInt(szInput.charAt(++x) + szInput.charAt(++x),16);
            if (!wch) {break;}
            if (!(wch & 0x80)) {
                wch = wch;
            } else if (!(wch & 0x20)) {
                x++;
                wch1 = parseInt(szInput.charAt(++x) + szInput.charAt(++x),16);
                wch  = (wch & 0x1F)<< 6;
                wch1 = wch1 & 0x3F;
                wch  = wch + wch1;
            } else {
                x++;
                wch1 = parseInt(szInput.charAt(++x) + szInput.charAt(++x),16);
                x++;
                wch2 = parseInt(szInput.charAt(++x) + szInput.charAt(++x),16);
                wch  = (wch & 0x0F)<< 12;
                wch1 = (wch1 & 0x3F)<< 6;
                wch2 = (wch2 & 0x3F);
                wch  = wch + wch1 + wch2;
            }
            szRet += String.fromCharCode(wch);
        } else {
            szRet += szInput.charAt(x);
        }
    }
    return(szRet);
}
</script>


<style>
    .el-button--small {
        width: 65px;
        height: 32px;
        font-size: 14px;
    }
    .el-button--primary:hover {
        background:rgba(120,180,255,1)!important;
        color: #FFFFFF!important;
        border: none!important;
    }
    .el-button--primary:focus {
        background:rgba(57,129,221,1)!important;
        color: #FFFFFF!important;
        border: none!important;
    }
    .el-upload{
        border: none!important;
    }
    .el-upload--text {
        border: none!important;
    }
</style>

<style scoped>
    .top {
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        margin-top: 12px;
        height: 52px;
    }
    .delete-button {
        margin-left: 20px;
        color: rgba(255,75,75,1) !important;
    }
    .delete-button:hover {
        color: rgba(255,75,75,0.8) !important;
    }
    .delete-button:focus {
        color: rgba(215,37,41,1) !important;
    }
    .dialog-set{
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
    }
    .select-box {
        display: flex;
        flex-direction: row;
        height: 36px;
        line-height:36px;
        margin-top: -25px;
        font-size: 14px
    }
    .select {
        padding: 0 15px;
        /*width: 80px;*/
        text-align: center
    }
    .active{
        box-shadow: 0 2px 0 rgba(97,167,255,1);
        color:rgba(97,167,255,1);
    }
    .tag-box {
            width: 288px;
            min-height: 30px;
            border-radius: 5px;
            border: 1px solid #DCDFE6;
            padding: 0 15px
        }
</style>